import React, { memo, useCallback } from 'react';
import LazyImage from '@gin-betting/components/lazy-image';

import useSportEventBg from './useSportEventBg';

import './sportEventBg.scss';

type Props = {
    competitorIds: string[];
    tournamentId: string;
    sportId: string;
};

const SportEventBg: React.FC<Props> = ({
    competitorIds,
    tournamentId,
    sportId,
}) => {
    const { containerRef, bg } = useSportEventBg({
        competitorIds,
        tournamentId,
        sportId,
    });

    const children = useCallback(
        ({ ref, bgImageStyle }) => (
            <div styleName="image" ref={ref} style={bgImageStyle} />
        ),
        []
    );

    return (
        <div
            ref={containerRef}
            styleName="container"
            className="__app-SportEventBg-container"
        >
            {bg && (
                <LazyImage isFullSize={true} url={bg}>
                    {children}
                </LazyImage>
            )}
        </div>
    );
};

export default memo(SportEventBg);
